






















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Site, Transceiver, TransceiversApi } from '@/api';
import Toast from '@/components/display/toast.vue';
import ConfirmModal from '@/components/display/confirm-modal.vue';
import { ApiUtils } from '@/common/ApiUtils';

@Component({
	components: { ConfirmModal },
})
export default class RemoveGatewayFromSite extends Vue {
	@Prop({ required: true, type: Object })
	public gateway!: Transceiver;

	@Prop({ required: true, type: Object })
	public site!: Site;

	public submitting = false;

	private readonly api: TransceiversApi = new TransceiversApi();
	private readonly toast = new Toast();
	private readonly modalId: string = `removeGatewayFromSiteModal${Math.random()}`;

	private async removeFromSite() {
		this.submitting = true;
		try {
			await this.api.updateTransceiver(this.gateway.id!, {
				data: {
					serialNumber: this.gateway.serialNumber,
					status: null,
					siteId: null,
				},
			});
			this.toast.makeToast('Gateway has been removed from its site', 'Success', 'success');
			this.$bvModal.hide(this.modalId);
			this.$emit('removed');
		} catch (ex) {
			const { errorMessage } = ApiUtils.handleApiError(ex, 'Error removing gateway from site');
			this.toast.makeToast(errorMessage, 'Error', 'danger');
		}
		this.submitting = false;
	}
}
